// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import Prologue from './Prologue';

export { Prologue as default };
